// UserSettingSlice.js
import { createSlice } from '@reduxjs/toolkit';

// LocalStorageのキー
export const LS_AI_CONFIG_KEY = 'pwappy_ai_config_v1';

// デフォルト設定
const defaultAiConfig = {
  coder: {
    model: 'gemini-flash-latest',
    temperature: '0.1',
    useOnsenUI: true
  },
  agent: {
    architectModel: 'gemini-flash-latest',
    documentationModel: 'gemini-flash-latest',
    maxHistory: 20,
    maxRecoveryAttempts: 3,
    executionMode: 'auto'
  }
};

const initialState = {
  aiCodingEnabled: false,
  isUserGeminiApiKeyRegistered: false,
  aiConfig: defaultAiConfig
};

const userSettingSlice = createSlice({
  name: 'userSetting',
  initialState,
  reducers: {
    loadUserSettingData(state, action) {
      state.aiCodingEnabled = action.payload.aiCodingEnabled || false;
      state.isUserGeminiApiKeyRegistered = action.payload.isUserGeminiApiKeyRegistered || false;
    },
    // AIコーディングの有効/無効を切り替えるReducer
    setAiCodingEnabled(state, action) {
      state.aiCodingEnabled = action.payload;
    },
    // APIキーの登録状況を切り替えるReducer
    setUserGeminiApiKeyRegistered(state, action) {
      state.isUserGeminiApiKeyRegistered = action.payload;
    },
    loadLocalAiConfig(state, action) {
      state.aiConfig = {
        coder: { ...defaultAiConfig.coder, ...action.payload.coder },
        agent: { ...defaultAiConfig.agent, ...action.payload.agent }
      };
    },
    updateAiCoderConfig(state, action) {
      state.aiConfig.coder = { ...state.aiConfig.coder, ...action.payload };
    },
    updateAiAgentConfig(state, action) {
      state.aiConfig.agent = { ...state.aiConfig.agent, ...action.payload };
    },
  }
});

export const {
  loadUserSettingData,
  setAiCodingEnabled,
  setUserGeminiApiKeyRegistered,
  loadLocalAiConfig,
  updateAiCoderConfig,
  updateAiAgentConfig } = userSettingSlice.actions;

export default userSettingSlice.reducer;